import { Button, CircularProgress } from "@mui/material";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import { buttonLoading, customStyle } from "./ViewOrderUtils";
import useShortcutKeys from "../../components/dms_common/ShortcutKeys";

interface PendingButtonsProps {
  handleClickReject?: () => void;
  handleClickSaveChanges: () => void;
  handleClickAccept?: () => void;
  isEditing: boolean;
  handleCancel: () => void;
  orderStatusChangeLoading: string;
  saveChangesLoading: boolean;
  batchIdConfiguration: boolean;
  showPushToGrnButton: boolean;
  handleModalOpen?: () => void;
  handleCreateInvoice: () => void;
  orderConfirmationEnabled?: boolean;
  isPrimary?: boolean;
  openingInvoiceModal?: boolean
}

export const PendingButtons: React.FC<PendingButtonsProps> = ({
  isEditing,
  handleClickReject,
  handleClickSaveChanges,
  handleClickAccept,
  handleCancel,
  orderStatusChangeLoading,
  saveChangesLoading,
  batchIdConfiguration,
  handleModalOpen,
  showPushToGrnButton,
  handleCreateInvoice,
  orderConfirmationEnabled,
  isPrimary = false,
  openingInvoiceModal = false,
}) => {

  const confirmButtonLoading = (buttonLoading(orderStatusChangeLoading, "CONFIRMED") || buttonLoading(orderStatusChangeLoading, "STOCKS")) 
  const saveChangesButtonLoading = saveChangesLoading || buttonLoading(orderStatusChangeLoading, "SAVE_CHANGES") 

   const { positiveCta, negativeCta } = useShortcutKeys();


  return (
    <div className="view_order_update_wrapper">
      {isEditing ? (
        <div className="view_order_action_buttons_wrapper">
          <Button
            onClick={handleCancel}
            sx={{
              cursor: "pointer",
              textTransform: "none",
              border: "1px solid #DEDEDE !important",
              color: "#7C7C7C !important",
              minWidth: "85px",
              fontSize: "12px",
            }}
          >
            Go back &nbsp;<span style={{fontSize:"9.5px"}}>{negativeCta}</span>
            
          </Button>
          <Button
            className="view_order_action_button"
            key={"CONFIRMED"}
            disabled={saveChangesButtonLoading}
            sx={{
              cursor: `${
                true ? "pointer !important" : "not-allowed !important"
              }`,
              color: `${true ? "#ffffff !important" : "#7C7C7C !important"}`,
              fontWeight: 500,
              fontSize: `12px !important`,
              backgroundColor: `${
                true ? "#00C6B1 !important" : "#F4F4F4 !important"
              }`,
              border: `${
                true
                  ? "1px solid #00C6B1 !important"
                  : "1px solid #F4F4F4 !important"
              }`,
              paddingLeft: "12px",
              letterSpacing: "0.0001rem",
              "&:hover": {
                backgroundColor: `${
                  true ? "#00C6B1 !important" : "#F4F4F4 !important"
                }`,
              },
              textTransform: "none",
              minHeight: "35px",
              minWidth: "108px"
            
            }}
            onClick={handleClickSaveChanges}
          >
            {saveChangesButtonLoading? <CircularProgress style={customStyle} /> : "Save changes" }
            &nbsp;<span style={{fontSize:"9.5px"}}>{positiveCta}</span>
          </Button>
        </div>
      ) : (
        <div className="view_order_action_buttons_wrapper">
          <Button
            startIcon={buttonLoading(orderStatusChangeLoading, "REJECTED") ? "" : <RenderSvg name={"viewOrderREJECTED"} />}
            className="view_order_action_button"
            key={"REJECTED"}
            sx={{
              minWidth: "100px",
              color: `#ffffff !important`,
              fontWeight: 500,
              fontSize: `12px !important`,
              backgroundColor: `#C64C00 !important`,
              border: `1px solid #C64C00 !important`,
              cursor: "pointer",
              letterSpacing: "0.0001rem",
              paddingLeft: "12px",
              "&:hover": {
                backgroundColor: `#C64C00 !important`,
              },
              textTransform: "none",
            }}
            onClick={handleClickReject}
            disabled={buttonLoading(orderStatusChangeLoading, "REJECTED")}
          >
            {buttonLoading(orderStatusChangeLoading, "REJECTED") ? (
              <CircularProgress style={customStyle} />
            ) : (
              "Cancel"
            )}
            &nbsp;<span style={{fontSize:"9.5px"}}>{negativeCta}</span>
          </Button>
          {(!orderConfirmationEnabled && !isPrimary) ? (<InvoiceOrGrnButton showPushToGrnButton={showPushToGrnButton} handleCreateInvoice={handleCreateInvoice} orderStatusChangeLoading={orderStatusChangeLoading?.length > 0} handleModalOpen={handleModalOpen} openingInvoiceModal={openingInvoiceModal} />) : (<Button
            startIcon={confirmButtonLoading ? "" : <RenderSvg name={"viewOrderCONFIRMED"} />}
            className="view_order_action_button"
            key={"CONFIRMED"}
            sx={{
              minWidth: "100px",
              color: `#ffffff !important`,
              fontWeight: 500,
              fontSize: `12px !important`,
              backgroundColor: `#00C6B1 !important`,
              border: `1px solid #00C6B1 !important`,
              cursor: "pointer",
              paddingLeft: "12px",
              letterSpacing: "0.0001rem",
              "&:hover": {
                backgroundColor: `#00C6B1 !important`,
              },
              textTransform: "none",
            }}
            onClick={handleClickAccept}
            disabled={confirmButtonLoading }
          >
            {confirmButtonLoading  ? (
              <CircularProgress style={customStyle} />
            ) : (
              "Confirm" 
            )}&nbsp;<span style={{fontSize:"9.5px"}}>{positiveCta}</span>
          </Button>)}
        </div>
      )}
    </div>
  );
};

interface CreateInvoiceButtonProps {
  handleModalOpen: () => void;
}

interface InvoiceOrGrnButtonProps {
  showPushToGrnButton: boolean;
  handleModalOpen?: () => void;
  handleCreateInvoice: () => void;
  orderStatusChangeLoading: boolean;
  openingInvoiceModal?: boolean;
  disabled?:boolean;
}

const customStyleG = {
  width: "16px",
  height: "16px",
  color: "#fff",
};

export const InvoiceOrGrnButton: React.FC<InvoiceOrGrnButtonProps> = ({
  showPushToGrnButton,
  handleModalOpen,
  handleCreateInvoice,
  orderStatusChangeLoading,
  openingInvoiceModal = false,
  disabled,
}) => {
  const { positiveCta } = useShortcutKeys();

  return (
    <Button
      className="view_order_action_button"
      disabled={disabled}
      sx={{
        minWidth: "100px",
        color: "#ffffff !important",
        fontWeight: 500,
        fontSize: "12px !important",
        backgroundColor: disabled ? "#E2E2E2 !important" : "#00C6B1 !important",
        border: disabled
          ? "1px solid #E2E2E2 !important"
          : "1px solid #00C6B1 !important",
        cursor: disabled ? "not-allowed" : "pointer",
        paddingLeft: "12px",
        letterSpacing: "0.0001rem",
        textTransform: "none",
        pointerEvents: disabled ? "none" : "auto",

      }}
      onClick={showPushToGrnButton ? handleCreateInvoice : (handleModalOpen && handleModalOpen)}
    >
      {showPushToGrnButton ? (
        orderStatusChangeLoading ? (
          <CircularProgress style={customStyleG} />
        ) : (
          "Push to GRN"
        )
      ) : (
        openingInvoiceModal ? 
        <CircularProgress style={{...customStyleG, width: "20px", height: "20px"}} />
        :
        <>
          Create Invoice&nbsp;<span style={{ fontSize: "9.5px" }}>{positiveCta}</span>
        </>
      )}
    </Button>
  );
};
